import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'

import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import download from 'downloadjs';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'
import {
    // AddShoppingCart as AddShoppingCartIcon,
    SettingsOutlined as SettingsIcon,
    ConfirmationNumber as ConfirmationNumberIcon,
    Group as GroupsIcon,
    PermContactCalendar, DoneAll, Assessment as AssessmentIcon, PanTool, Build
} from '@material-ui/icons'
import DiscountIcon from '@mui/icons-material/Discount';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'; // This one
import TuneIcon from '@mui/icons-material/Tune'; // This one
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import BadgeIcon from '@mui/icons-material/Badge'
import PaidIcon from '@mui/icons-material/Paid';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import EmailIcon from '@mui/icons-material/Email';
import SummarizeIcon from '@mui/icons-material/Summarize';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import { useAutoEvt } from '../../queries/useAutoEvt'
import styles from './EventPage.module.css'
import {useAuctionInfo, useEventInfo} from "../../queries/useFetchAuctionInfo";
import {useDispatch} from "react-redux";
import {setEvtUrl, useEvtState} from "../../slices/evtSlice";
import React, {useEffect} from "react";
import axios from "axios";

interface Params {
  id: string
}

const EventPage = () => {
    const history = useHistory()
    const { id } = useParams<Params>()
    const dispatch = useDispatch()
    // useAutoEvent(id)
    useAutoEvt(id)

    const {data} = useAuctionInfo(id)
    const {data: eventData} = useEventInfo(id)
    const eventState = useEvtState()
    dispatch(setEvtUrl(eventData.eventlink))

    useEffect(() => {
        if (eventData?.eventname) {
            document.title = 'EventSnap - ' + eventData?.eventname;
        }
    }, [eventData]);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      button: {
        margin: theme.spacing(1)
      },
      paper: {
        padding: theme.spacing(2),
        spacing: theme.spacing(100),
        paddingLeft: 10,
        marginLeft: 10,
        marginRight: 10,
        textAlign: 'left',
        fontSize: 25,
        color: theme.palette.text.secondary
      }
    })
  )
    const classes = useStyles()
    const generatePurchaseSummaryClick = async () => {
        axios.post('/evtpurchasersummaryreport', {eventid: eventState.eventId}, {responseType: "blob"}).then(response => {
            var filename = eventState.eventName + '-purchasesummary.xlsx';
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (response.data) {
                download(response.data, filename, contentType);
            }
        })
    }

  return (
    <div className={styles.root}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>Event Setup</Paper>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            size="large"
            color="primary"
            className={classes.button}
            onClick={() => {
              history.push('/event/' + eventState.eventId + '/settings')
            }}
            startIcon={<SettingsIcon />}>
            Event Settings
          </Button>
        </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
              variant="contained"
              size="large"
              color="primary"
              className={classes.button}
              onClick={() => {
                  history.push('/event/' + eventState.eventId + '/pagebuilder')
              }}
              startIcon={<ImportantDevicesIcon />}>
              Event Page Builder
          </Button>
        </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            onClick={() => {
              history.push('/event/' + eventState.eventId + '/userdefined')
            }}
            startIcon={<TuneIcon />}>
            User Defined Fields
          </Button>
        </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<AddShoppingCartIcon  />}
            onClick={() => {
              history.push('/event/' + eventState.eventId + '/eventitems')
            }}
          >
            Tickets and Items
          </Button>
        </Grid>
          <Grid item xs={4} className={styles.selectcontrol}>
              <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  onClick={() => {
                      history.push('/event/' + eventState.eventId + '/discountcodes')
                  }}
                  startIcon={<DiscountIcon />}>
                  Promo Codes
              </Button>
          </Grid>
          <Grid item xs={4} className={styles.selectcontrol}>
              <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  onClick={() => {
                      history.push('/event/' + eventState.eventId + '/EventEmailCustomization')
                  }}
                  startIcon={<EditIcon />}>
                  Email Customization
              </Button>
          </Grid>
      </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>Event Activity</Paper>
      </Grid>
      <Grid container spacing={1}>
          <Grid item xs={4} className={styles.selectcontrol}>
              <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  onClick={() => {
                      history.push('/event/' + eventState.eventId + '/transactions')
                  }}
                  startIcon={<PaidIcon />}>
                  EVENT TRANSACTIONS
              </Button>
          </Grid>
          <Grid item xs={4} className={styles.selectcontrol}>
              <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  onClick={() => {
                      history.push('/event/' + eventState.eventId + '/activitytickets')
                  }}
                  startIcon={<LocalActivityIcon />}>
                  TICKET MAINTENANCE
              </Button>
          </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            onClick={() => {
              history.push('/event/' + eventState.eventId + '/eventguestmaintenance')
            }}
            startIcon={<GroupsIcon />}>
            Guest Maintenance
          </Button>
        </Grid>
      </Grid>
        <Grid container spacing={1}>
            <Grid item xs={4} className={styles.selectcontrol}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.button}
                    onClick={() => {
                      history.push('/event/' + eventState.eventId + '/eventgroupmaintenance')
                    }}
                    startIcon={<WorkspacesIcon />}>
                    Group Maintenance
                </Button>
            </Grid>
            <Grid item xs={4} className={styles.selectcontrol}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.button}
                    onClick={() => {
                      history.push('/event/' + eventState.eventId + '/EventMassEmailMaintenanceTable')
                    }}
                    startIcon={<EmailIcon />}>
                    Email
                </Button>
            </Grid>
            <Grid item xs={4} className={styles.selectcontrol}>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.button}
                    onClick={() => {
                        history.push('/event/' + eventState.eventId + '/EventCheckIn')
                    }}
                    startIcon={<DoneAll />}>
                    Check In
                </Button>
            </Grid>
        </Grid>

      <Grid item xs={12}>
        <Paper className={classes.paper}>Event Reports</Paper>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<PermContactCalendar />}
          onClick={() => {
            history.push('/event/' + eventState.eventId + '/eventguestinformation')
          }}
          >
            Guest Information
          </Button>
        </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<BadgeIcon />}
            onClick={() => {
                history.push('/event/' + eventState.eventId + '/nametags')
            }}
          >
            Name Tags
          </Button>
        </Grid>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SummarizeIcon />}
          onClick={() => {
            history.push('/event/' + eventState.eventId + '/grouplistingreport')
          }}
          >
              Group Listing Report
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {/*<Grid item xs={4} className={styles.selectcontrol}>*/}
        {/*  <Button*/}
        {/*    variant="contained"*/}
        {/*    color="primary"*/}
        {/*    size="large"*/}
        {/*    className={classes.button}*/}
        {/*    startIcon={<LeaderboardIcon />}*/}
        {/*  // onClick={() => {*/}
        {/*  //   history.push('/auction/' + eventState.eventId + '/AuctionSummaryReportPage')*/}
        {/*  // }}*/}
        {/*  >*/}
        {/*    Event Summary*/}
        {/*  </Button>*/}
        {/*</Grid>*/}
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.button}
              startIcon={<ReceiptLongIcon />}
              onClick={() => {
                  generatePurchaseSummaryClick()
              }}
          >
              Export Purchase Summary
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>Integrations</Paper>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.button}
              startIcon={<CurrencyExchangeIcon />}
              onClick={() => {
                history.push('/event/' + eventState.eventId + '/eventpurchaserlink')
              }}
          >
              Purchaser Link / Transfer
          </Button>
        </Grid>
        {/*<Grid item xs={4} className={styles.selectcontrol}>*/}
        {/*  <Button*/}
        {/*      variant="contained"*/}
        {/*      color="primary"*/}
        {/*      size="large"*/}
        {/*      className={classes.button}*/}
        {/*      startIcon={<AssessmentIcon />}*/}
        {/*      onClick={() => {*/}
        {/*          history.push('/event/' + eventState.eventId + '/EventTransferPage')*/}
        {/*      }}>*/}
        {/*      Transfer/Export*/}
        {/*  </Button>*/}
        {/*</Grid>*/}
        <Grid item xs={4} className={styles.selectcontrol}>
          <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.button}
              startIcon={<TransferWithinAStationIcon />}
              onClick={() => {
                  history.push('/event/' + eventState.eventId + '/eventguestlink')
              }}
          >
              Guest Link / Transfer
          </Button>
        </Grid>
        {/*<Grid item xs={4} className={styles.selectcontrol}>*/}
        {/*  <Button*/}
        {/*    variant="contained"*/}
        {/*    color="primary"*/}
        {/*    size="large"*/}
        {/*    className={classes.button}*/}
        {/*    startIcon={<PermContactCalendar />}*/}
        {/*  // onClick={() => {*/}
        {/*  //   history.push('/auction/' + eventState.eventId + '/AuctionSummaryReportPage')*/}
        {/*  // }}*/}
        {/*  >*/}
        {/*    AuctionSnap*/}
        {/*  </Button>*/}
        {/*</Grid>*/}
        {/*<Grid item xs={4} className={styles.selectcontrol}>*/}
        {/*  <Button*/}
        {/*    variant="contained"*/}
        {/*    color="primary"*/}
        {/*    size="large"*/}
        {/*    className={classes.button}*/}
        {/*    startIcon={<PermContactCalendar />}*/}
        {/*  // onClick={() => {*/}
        {/*  //   history.push('/auction/' + eventState.eventId + '/AuctionSummaryReportPage')*/}
        {/*  // }}*/}
        {/*  >*/}
        {/*    DonorSnap*/}
        {/*  </Button>*/}
        {/*</Grid>*/}
      </Grid>
      {/*<Grid item xs={12}>*/}
      {/*  <Paper className={classes.paper}>Maintenance</Paper>*/}
      {/*</Grid>*/}
      {/*<Grid container spacing={1}>*/}
      {/*  <Grid item xs={4} className={styles.selectcontrol}>*/}
      {/*    <Button*/}
      {/*      variant="contained"*/}
      {/*      color="primary"*/}
      {/*      size="large"*/}
      {/*      className={classes.button}*/}
      {/*      startIcon={<PermContactCalendar />}*/}
      {/*    // onClick={() => {*/}
      {/*    //   history.push('/auction/' + eventState.eventId + '/AuctionSummaryReportPage')*/}
      {/*    // }}*/}
      {/*    >*/}
      {/*      Merge Participants*/}
      {/*    </Button>*/}
      {/*  </Grid>*/}
      {/* */}
      {/*</Grid>*/}
    </div>
  )
}

export default EventPage
